// @LTG-ID: F-009
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-009, source Landing Page.html lines 1448-1480
// @CHANGED: 2026-02 session_002
// @OWNER: web

import { useState } from "react";
import { PATHS } from "../../data/paths";
import "./three-paths.css";

export function ThreePaths() {
    const [active, setActive] = useState(1);

    return (
        <section
            className="ltg-block ltg-paths-block"
            id="paths"
            data-testid="three-paths"
        >
            <div className="ltg-container">
                <div className="ltg-block-head">
                    <span className="ltg-eyebrow">What we do</span>
                    <h2>
                        Three reasons owners <em>call us.</em> Pick the one
                        that's actually you.
                    </h2>
                </div>
                <div className="ltg-paths">
                    {PATHS.map((p, i) => {
                        const isActive = active === i;
                        return (
                            <button
                                key={p.num}
                                type="button"
                                className={`ltg-path-card ${isActive ? "is-active" : ""}`}
                                onMouseEnter={() => setActive(i)}
                                onClick={() => setActive(i)}
                                aria-pressed={isActive}
                                data-testid={`path-card-${i}`}
                            >
                                <span className="ltg-path__num">{p.num}</span>
                                <h3 className="ltg-path__title">
                                    {p.title}
                                    <span
                                        className="ltg-bubble-period"
                                        style={{
                                            "--bp-color": isActive
                                                ? "var(--teal-bright)"
                                                : "var(--teal)",
                                        }}
                                        aria-hidden="true"
                                    />
                                </h3>
                                <p className="ltg-path__desc">{p.desc}</p>
                                <ul className="ltg-path__list">
                                    {p.list.map((l) => (
                                        <li key={l}>{l}</li>
                                    ))}
                                </ul>
                                <div className="ltg-path__detail">
                                    <span className="ltg-path__detail-label">
                                        {p.detailLabel}
                                    </span>
                                    <span className="ltg-path__detail-val">
                                        {p.detailVal}
                                    </span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default ThreePaths;
